<div class="row align-items-center mb-5">
  <a (click)="volverAsignaturasPorPeriodo()">
    <button
      class="boton_volver"
      data-toggle="tooltip"
      data-placement="top"
      title="VOLVER"
      alt="VOLVER"
    >
      <i class="bi bi-chevron-left mr-2"></i>
      Volver al HOME
    </button>
  </a>
</div>

<div class="mb-5">
  <h1 class="h1-text">Alineación con Blackboard</h1>
  <div class="row mt-5 align-items-center" *ngIf="vista === 'Validar'">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0 h6-text">
      En esta sección puede visualizar que sección del curso seleccionado en
      Portal de Calificaciones, cuenta con una alineación vigente con un curso
      de Blackboard. Esta alineación puede confirmarse o editarse. Una vez
      realizada esta acción, puede obtener las calificaciones en el registro de
      calificaciones según las columnas que elija.
    </h6>
    
  </div>
  <div class="row mt-5 align-items-center" *ngIf="vista === 'Configurar'">
    <div class="hr-amarillo mr-3"></div>
    <h6 class="mb-0 h6-text">
      En esta sección puede realizar la integración de calificaciones de la
      sección de la asignatura del Portal de Calificaciones, con las
      calificaciones del curso de Blackboard correspondiente. Una vez realizada
      esta acción, puede obtener las calificaciones en el registro según las
      columnas que elija y así cargarlas de forma automátizada.
    </h6>
  </div>
</div>

<div class="container my-3">
  <div class="row position-relative">
    <div class="col-12">
      <h6 class="titulo-seccion">Sección de Portal de Calificaciones</h6>
      <div class="info-box bg-light text-seccion-container">
        <span class="text-seccion-container pr-2"
          >Sección de Portal de calificaciones:
        </span>
        <strong>{{ filtrosSeccion.nombreSeccion }}</strong>
        <span class="text-seccion-container mx-4">|</span>
        <span class="text-seccion-container pr-2">Nombre: </span>
        <strong>{{ filtrosSeccion.nombreAsignatura }}</strong>
      </div>
    </div>

    <div class="arrow-line-container">
      <div class="line-horizontal"></div>
      <div class="line mt-0"></div>
      <i class="bi bi-arrow-repeat arrow-icon"></i>
      <div class="line"></div>
      <div class="line-horizontal"></div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <h6 class="titulo-seccion">Curso en Blackboard</h6>
      <div class="info-box bg-secondary text-seccion-container text-white">
        <span class="text-seccion-container pr-2"
          >ID de curso de Blackboard:
        </span>
        <strong>ID DE CURSO: {{ filtrosSeccion.nombreAsignaturaBB }}</strong>
        <span class="text-seccion-container mx-4">|</span>
        <span class="text-seccion-container pr-2">Nombre: </span>
        <strong>{{ filtrosSeccion.nombreSeccionBB }}</strong>
      </div>
    </div>
  </div>
</div>

<div class="form-container mt-5">
  <div class="row pt-5 align-items-center mx-5">
    <div class="hr-amarillo mr-3 drag-linea"></div>
    <h6 class="mb-0 h6-text drag" *ngIf="vista === 'Validar' || vista === 'Habilitada'">
      En la COLUMNA A se visualiza el listado de calificaciones de la sección de
      la asignatura. Mientras que en la COLUMNA B se visualizan las evaluaciones
      que se han alineado desde Blackboard. Por último, la COLUMNA C,
      corresponde a las demás evaluaciones disponibles en Blackboard para
      sincronizar.
    </h6>
    <h6 class="mb-0 h6-text drag" *ngIf="vista === 'Editar'">
      Para integrar las calificaciones, arrastre las calificaciones disponibles
      de la COLUMNA C (calificaciones de Blackboard), hacia la COLUMNA B para
      que coincidan con las de la COLUMNA A (calificaciones de Portal de
      Calificaciones)
    </h6>
    <h6 class="mb-0 h6-text drag" *ngIf="vista === 'Configurar'">
      Para alinear las calificaciones, arrastre las calificaciones disponibles
      de la COLUMNA C (calificaciones de Blackboard), hacia la COLUMNA B para
      que coincidan con las de la COLUMNA A (calificaciones de Portal de
      Calificaciones)
    </h6>
  </div>
  <div class="dragAndDrop-container py-5 mx-5">
    <div class="titulosContainer" #titulosContainer>
      <div class="tituloA titulo">
        <p class="titulo-columna">COLUMNA A</p>
        <mat-card class="custom-card">
          <mat-card-header
            class="custom-card-header custom-card-header-A text-center"
          >
            <mat-card-title
              >Sección:<br />
              <b>{{ routerData.datosSeccion.nombreSeccion }}</b></mat-card-title
            >
          </mat-card-header>
          <mat-card-content class="custom-card-body">
            <p>Evaluaciones de Portal de Calificaciones</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="tituloB titulo">
        <p class="titulo-columna">COLUMNA B</p>
        <mat-card class="custom-card">
          <mat-card-header
            class="custom-card-header custom-card-header-B text-center"
          >
            <mat-card-title>Alineación</mat-card-title>
          </mat-card-header>
          <mat-card-content class="custom-card-body">
            <p>Evaluaciones Seleccionadas de Blackboard</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="tituloC titulo">
        <p class="titulo-columna">COLUMNA C</p>
        <mat-card class="custom-card custom-card-C">
          <mat-card-header
            class="custom-card-header custom-card-header-C text-center"
          >
            <mat-card-title
              >ID DE CURSO:<br />
              <b>{{ routerData.datosSeccion.nombreAsignaturaBB }}</b></mat-card-title
            >
          </mat-card-header>
          <mat-card-content class="custom-card-body">
            <p>Evaluaciones Disponibles de Blackboard</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <div class="listaContainers" #listaContainers>
      <div class="listaA lista">
        <mat-card
          class="custom-card custom-card-lista"
          *ngFor="let prueba of pruebas"
          [ngClass]="{ 'custom-card-lista-disabled': deshabilitado }"
        >
          <mat-card-content class="custom-card-list-body">
            <p class="nota-lista">{{ prueba }}</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="listaB lista">
        <div *ngFor="let evaluacion of evaluacionesAsignadas; let i = index">
          <div
            cdkDropList
            [cdkDropListData]="evaluacion.evaluacion"
            [cdkDropListConnectedTo]="connectedDropLists"
            (cdkDropListDropped)="drop($event, i + evaluaciones.length)"
            [id]="'cdk-drop-list-' + (i + evaluaciones.length).toString()"
          >
            <mat-card
              class="custom-card"
              cdkDrag
              [cdkDragDisabled]="
                evaluacion.evaluacion[0].nombre === '' || deshabilitado
              "
              [ngClass]="{
                'custom-card-lista': evaluacion.evaluacion[0].nombre !== '',
                'custom-card-lista-empty':
                  evaluacion.evaluacion[0].nombre === '',
                'custom-card-lista-disabled': deshabilitado
              }"
            >
              <mat-card
                class="custom-card-preview custom-card-lista card-preview"
                *cdkDragPreview
              >
                <mat-card-content class="custom-card-list-body">
                  <p style="font-family: LatoRegular, sans-serif">Actividad</p>
                  <p class="evaluacion-texto-preview">
                    {{ evaluacion.evaluacion[0].nombre }}
                  </p>
                  <span>({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span>
                </mat-card-content>
              </mat-card>
              <mat-card-content
                class="custom-card-list-body"
                *ngIf="evaluacion.evaluacion[0].nombre != ''"
              >
                <p style="font-family: LatoRegular, sans-serif">Actividad</p>
                <p class="evaluacion-texto">
                  {{ evaluacion.evaluacion[0].nombre }}
                </p>
                <span>({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span>
              </mat-card-content>
              <mat-card-content
                class="custom-card-list-body lista-vacia"
                *ngIf="evaluacion.evaluacion[0].nombre === ''"
              >
                <p></p>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
      <div class="listaC lista">
        <div
          *ngFor="let evaluacion of listaCompletaEvaluaciones; let i = index"
        >
          <div
            cdkDropList
            [cdkDropListData]="evaluacion.evaluacion"
            [cdkDropListConnectedTo]="connectedDropLists"
            (cdkDropListDropped)="drop($event, i, 'evaluacionesSort')"
            [id]="'cdk-drop-list-' + i.toString()"
            *ngIf="i < evaluaciones.length"
          >
            <mat-card
              class="custom-card"
              cdkDrag
              [cdkDragDisabled]="
                evaluacion.evaluacion[0].nombre === '' || deshabilitado
              "
              [ngClass]="{
                'custom-card-lista': evaluacion.evaluacion[0].nombre !== '',
                'custom-card-lista-empty':
                  evaluacion.evaluacion[0].nombre === '',
                'custom-card-lista-disabled': deshabilitado
              }"
            >
              <mat-card
                class="custom-card-preview custom-card-lista card-preview"
                *cdkDragPreview
              >
                <mat-card-content class="custom-card-list-body">
                  <p style="font-family: LatoRegular, sans-serif">Actividad</p>
                  <p class="evaluacion-texto-preview">
                    {{ evaluacion.evaluacion[0].nombre }}
                  </p>
                  <span>({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span>
                </mat-card-content>
              </mat-card>
              <mat-card-content
                class="custom-card-list-body"
                *ngIf="evaluacion.evaluacion[0].nombre != ''"
              >
                <p style="font-family: LatoRegular, sans-serif">Actividad</p>
                <p class="evaluacion-texto">
                  {{ evaluacion.evaluacion[0].nombre }}
                </p>
                <span>({{ evaluacion.evaluacion[0].puntaje }} Puntos)</span>
              </mat-card-content>
              <mat-card-content
                class="custom-card-list-body lista-vacia"
                *ngIf="evaluacion.evaluacion[0].nombre === ''"
              >
                <p></p>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="py-5 text-center">
  <div class="mb-5" *ngIf="vista !== 'Habilitada'">
    <h6 class="mb-0 h6-text text-center">
      {{
        vista === "Validar"
          ? "¿Desea confirmar la alineación realizada hasta ahora?"
          : "¿Desea confirmar la alineación realizada?"
      }}
    </h6>
  </div>
  <div class="justify-content-center">
    <button
      class="boton-secundario mr-3"
      (click)="habilitarEdicion()"
      *ngIf="vista === 'Validar' || vista === 'Habilitada'"
    >
      PREFIERO EDITAR
    </button>

    <button
      class="boton-secundario mr-3"
      (click)="mostrarModal()"
      *ngIf="vista === 'Editar' || vista === 'Configurar'"
    >
      CANCELAR Y VOLVER AL REGISTRO
    </button>
    <button
      class="boton-primario"
      [disabled]="deshabilitarBtnCrear()"
      (click)="guardarAlineacion()"
      *ngIf="vista !== 'Habilitada'"
    >
      CONFIRMAR ALINEACIÓN
    </button>
    <button
      class="boton-primario"
      (click)="volverAsignaturasPorPeriodo()"
      *ngIf="vista === 'Habilitada'"
    >
      CERRAR
    </button>
  </div>
</div>

<!-- MODAL CONFIRMAR -->
<button
  id="modal-confirmar"
  class="btn d-none"
  data-toggle="modal"
  data-target="#confirmar"
>
  CERRAR Confirmar Integración
</button>
<div
  class="modal fade"
  id="confirmar"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          title="CERRAR"
          alt="CERRAR"
        >
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row my-3 mx-4 text-container-confirmar">
            <p class="mb-3">
              ¿Está seguro que quiere cancelar la alineación realizada?
            </p>
            <p class="mb-3 alineacion-completa">
              Esto implica que no se integrarán las columnas con Blackboard
              alineadas hasta ahora
            </p>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button
            class="boton-secundario ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="NO, QUIERO CONTINUAR"
            alt="NO, QUIERO CONTINUAR"
            data-dismiss="modal"
            id="btn-modal-salir-dismiss"
          >
            NO, QUIERO CONTINUAR
          </button>
          <button
            class="boton_principal_modal ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="SI, CANCELAR"
            alt="SI, CANCELAR"
            data-dismiss="modal"
            (click)="volverAsignaturasPorPeriodo()"
          >
            SI, CANCELAR
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL CONFIRMAR -->

<!-- MODAL ERROR -->
<button
  id="modal-error"
  class="btn d-none"
  data-toggle="modal"
  data-target="#error"
>
  CERRAR error Integración
</button>
<div
  class="modal fade"
  id="error"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header align-items-center">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          title="CERRAR"
          alt="CERRAR"
        >
          <div class="icono-cerrar mr-3" aria-hidden="true">&times;</div>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row my-3 mx-4 text-container-error">
            <p class="mb-3">
              {{mensajeError[0]}}
            </p>
            <p class="mb-3 alineacion-completa" *ngIf="mensajeError.length > 1">
              {{mensajeError[1]}}
            </p>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-center">
        <div class="my-4">
          <button
            class="boton-secundario ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="Editar alineación"
            alt="Editar alineación"
            data-dismiss="modal"
            id="btn-modal-salir-dismiss"
            *ngIf="mensajeError.length > 1"
            (click)="redirigirEditar()"
          >
            Editar alineación
          </button>
          <button
            class="boton-secundario ml-3"
            data-toggle="tooltip"
            data-placement="top"
            title="Continuar"
            alt="Continuar"
            data-dismiss="modal"
            id="btn-modal-salir-dismiss"
            *ngIf="mensajeError.length === 1"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FIN MODAL ERROR -->


